export interface ITakeObj {
  file: File[],
  objectUrl: string;
  videoLength: number;
}

interface IFilesQuestion {
  [questionNumber: number]: ITakeObj[];
}

export interface InitialState {
  questions: IFilesQuestion,
  practice: IFilesQuestion,
}

export const enum EVENTS {
  STORE_TAKE = 'STORE_TAKE',
  GET_TAKE = 'GET_TAKE',
  GET_TAKES = 'GET_TAKES',
  REMOVE_TAKES = 'REMOVE_TAKES',
}

export const enum ACTIONS {
  CONSOLE_LOG = 'consoleLog',
  STORE_TAKE = 'storeTake',
  SEND_TAKE = 'sendTake',
  SEND_TAKES = 'sendTakes',
  REMOVE_TAKES = 'removeTakes',
}

export const enum TAKE_TYPES {
  QUESTION = 'question',
  PRACTICE = 'practice',
}
